(() => {
  const handle = "seibertron-tactical-fingerless-leather-gloves";
  const assetName = "thfig2-half-tactical-size-chart-user-20260728-v1.jpg";
  const oldAssetName = "thfig-half-finger-size-chart.jpg";
  const alt = "Seibertron T.H.F.I.G 2.0 fingerless tactical adult gloves size chart with palm circumference measurement method";
  const width = 1000;
  const height = 1000;

  function isTargetPage() {
    return location.pathname.indexOf('/products/' + handle) !== -1;
  }

  function chartUrl() {
    const script = document.currentScript || Array.prototype.slice.call(document.scripts).find((node) => {
      return String(node.src || '').indexOf('thfig-half-finger-sizechart-restore-20260714') !== -1;
    });
    if (script && script.src) {
      try {
        return new URL(assetName + '?v=202607281230', script.src).href;
      } catch (error) {}
    }
    return '/cdn/shop/files/' + assetName + '?v=202607281230';
  }

  function apply() {
    if (!isTargetPage()) return;
    document.querySelectorAll('img').forEach((img) => {
      const src = String(img.getAttribute('src') || '');
      const text = String(img.getAttribute('alt') || '');
      const isSizeChart =
        src.indexOf(oldAssetName) !== -1 ||
        src.indexOf(assetName) !== -1 ||
        /T\.H\.F\.I\.G.*size chart/i.test(text);
      if (!isSizeChart) return;
      img.src = chartUrl();
      img.srcset = '';
      img.alt = alt;
      img.width = width;
      img.height = height;
      img.loading = 'lazy';
      img.decoding = 'async';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  setTimeout(apply, 600);
  setTimeout(apply, 1800);
})();